// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9c-3";
export var contentContainer = "_9c-0";
export var editorContainer = "_9c-1";
export var quillInputForm = "_9c-2";
export var zoneDivider = "_9c-4";